const ProjectItems = [
  {
    id: 1,
    title: "PodCast App",
    description:
      "A website for a podcast brand. Converted a figma design into a functional and interactive React application for a client.",
    websiteLink: "https://my-podcast-one.vercel.app/",
    videoDemo: "",
    githubLink: "https://github.com/Milayo/myPodcast",
  },
  {
    id: 2,
    title: "Veriface",
    description:
      "Veriface is a verification interface that helps you limit interactions with bad actors in your smart contract.",
    websiteLink: "https://veriface.vercel.app/",
    videoDemo: "",
    githubLink: "https://github.com/Veriface/Veriface-frontend",
  },  
  {
    id: 3,
    title: "UNICOMP School Portal",
    description:
      "A university school portal with features like Fees Payment via Card and Crypto, Course Registration, Profile Editing and Course Scheduling. Built with REACT JS, ROUTER, FIREBASE, MORALIS, PAYSTACK, STYLED COMPONENTS, CHAKRA UI and FORMIK.",
    websiteLink: "https://unicomp.vercel.app/",
    videoDemo:
      "https://www.loom.com/share/cc720f70207a4ac698fc1ecd0d6c6773?sharedAppSource=personal_library",
    githubLink: "https://github.com/Milayo/unicomp",
  },
  {
    id: 4,
    title: "Seer NFT App",
    description:
      "An NFT application to view your NFT collections from LearnWeb3DAO and Buildspace. Built with Next JS, Typescript, wagmi and Alchemy API",
    websiteLink: "https://seernft-app.vercel.app/",
    videoDemo: "",
    githubLink: "https://github.com/Milayo/Web3-NFT-project",
  },
  {
    id: 5,
    title: "Hand2Hand Crowdfunding Website",
    description:
      "Hand2Hand is a decentralized crowdfunding website where users can create or donate to financing campaigns. Built with REACT JS, REDUX, ROUTER, MORALIS, SASS, and MATERIAL UI.",
    websiteLink: "https://hand-in-hand-or427i6r6-veeglass.vercel.app/",
    videoDemo:
      "https://www.loom.com/share/8b8534c8e9f14d199fffc07cb7d178e3?sharedAppSource=personal_library",
    githubLink: "https://github.com/Milayo/hand-in-hand",
  },
  {
    id: 6,
    title: "Travel BNB",
    description:
      "Travel BNB is a travel website where you can search for travel destinations, read their reviews, make bookings, and pay with credit card. Built with REACT JS, REDUX, REDUX-PERSIST, ROUTER, CONTEXT API, SASS, STRIPE, FIREBASE.",
    websiteLink: "",
    videoDemo: "https://www.loom.com/share/b6c9faa1649a4e8bad6aa285fdbf60e1",
    githubLink: "https://github.com/Milayo/travelbnb",
  },
  {
    id: 7,
    title: "Tellium",
    description:
      "A communication platform that allows users to keep in touch with their family, friends and loved ones. Built with REACT JS, ROUTER, MATERIAL UI, REACT BOOTSTRAP, REACT ANIMATED CSS, SASS, REDUX, REDUX PERSIST, FORMIK, and FIREBASE.",
    websiteLink: "",
    videoDemo: "",
    githubLink: "https://github.com/Milayo/tellium",
  },

  {
    id: 8,
    title: "FilmTUBE",
    description:
      "A Youtube clone website. Built with REACT JS, ROUTER, MDBOOTSTRAP, REACT YOUTUBE, SASS, REDUX, REACT PLAYER, AXIOS, and FIREBASE.",
    websiteLink: "",
    videoDemo: "",
    githubLink: "https://github.com/Milayo/youtube-clone-app",
  },
  {
    id: 9,
    title: "Portfolio",
    description:
      "A portfolio website. Built with REACT JS, SASS, FRAMER MOTION, EMAIL JS, REACT SCROLL, REACT-REVEAL AND SWEET ALERT.",
    websiteLink: "https://tomilayo-portfolio-milayo.vercel.app",
    videoDemo: "https://www.loom.com/share/ede98ceeee844ca5aef0573e7b8c9043",
    githubLink: "https://github.com/Milayo/portfolio-website",
  },
  {
    id: 10,
    title: "Daily Agenda Application",
    description:
      "A daily agenda application. Built with REACT JS, ROUTER, FIREBASE, REDUX, FIREBASE and MDBREACT.",
    websiteLink: "https://mila-agenda-app.herokuapp.com/agendapage",
    videoDemo: "https://www.loom.com/share/fb4e7337f9924c159be0ef7180c44a84",
    githubLink: "https://github.com/Milayo/agenda-app",
  },
];

export default ProjectItems;
